// Generated by CoffeeScript 2.7.0
import {
  SelectOption,
  SelectOptionProxy
} from './select_option.js';

export var FieldOptionProxy = class FieldOptionProxy extends SelectOptionProxy {
  constructor(option, value) {
    super(option, value);
    this.delegateTo(['incrementCounter', 'decrementCounter', 'isOverLimit', 'textValue', 'limitReached'], this.option);
  }

};

export var FieldOption = (function() {
  class FieldOption extends SelectOption {
    constructor(attrs = {}, optionable) {
      super(attrs);
      this.optionable = optionable;
      this.isOtherOption = attrs.id === 0;
      if (!this.isOtherOption) {
        this.label = this.value;
      }
      this.settings = _.extend({}, {
        limit_settings: {
          max: null,
          text: '超过限制'
        }
      }, attrs.settings);
      this.valid_hit_count = parseInt(this.valid_hit_count);
      if (this._limitControlled() && this.valid_hit_count > this._maxHitCount()) {
        this.valid_hit_count = this._maxHitCount();
      }
    }

    incrementCounter() {
      return this._updateCounter(1);
    }

    decrementCounter() {
      return this._updateCounter(-1);
    }

    isOverLimit() {
      return this._limitControlled() && this.valid_hit_count > this._maxHitCount();
    }

    toJSON() {
      var option;
      option = super.toJSON();
      return _.omit(option, 'isOtherOption');
    }

    textValue(checked = false) {
      var label, left_count;
      label = this.isOtherOption ? this.label : this.value;
      if (this._limitControlled()) {
        if (this.limitReached()) {
          if (checked) {
            return `${label}（余1）`;
          } else {
            return `${label}（${this._limitReachedText()}）`;
          }
        } else {
          left_count = this._maxHitCount() - this.valid_hit_count;
          return `${label}（余${left_count}）`;
        }
      } else {
        return label;
      }
    }

    limitReached() {
      return this._limitControlled() && this.valid_hit_count >= this._maxHitCount();
    }

    _updateCounter(delta) {
      return this.valid_hit_count = this.valid_hit_count + delta;
    }

    _maxHitCount() {
      return parseInt(this.settings.dig('limit_settings', 'max'));
    }

    _limitControlled() {
      return this._maxHitCount() >= 0;
    }

    _limitReachedText() {
      return this.settings.dig('limit_settings', 'text') || '超过限制';
    }

  };

  FieldOption.setAttributes([
    'position',
    {
      valid_hit_count: 0,
      settings: {}
    },
    'value',
    'isOtherOption'
  ]);

  return FieldOption;

}).call(this);

export default FieldOption;
